<template>
    <div>
    <div id="arcplot"></div>
    </div>
</template>

<script>
import * as d3 from "d3";


export default {
    allFlux: null,
    dataToNodes: [],
    dataToGraph: [],
    selectedYear: null,
    selected: null,
    props: {
    year: {
    },
    flowType: {
      type: String,
    },
    selectedAirport: {}
  },
    data() {
        return {
            dataSelected: null,
            };
            },
  created(){
    this.selectedYear = this.$props.year;
    this.selected = this.$props.selectedAirport;
  },
  async mounted(){
    
      await import("../data/all_flux.json").then((res)=>{ 
       return JSON.parse(JSON.stringify(res))
       })
       .then((e)=>{
           this.allFlux = e;
       })
var margin = {
    top: 0, right: 30, bottom: 50, left: 60
    },
  width = 500 - margin.left - margin.right,
  height = 400 - margin.top - margin.bottom;


var svg = d3.select("#arcplot")
  .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
  .append("g")
    .attr("transform",
          "translate(" + margin.left + "," + margin.top + ")");

      await import("../data/DATA_OK.json").then((res)=>{ 
       return JSON.parse(JSON.stringify(res))
       })
      .then((e) => {
          let nodes = [];
          let groups = [];
          let dataFlux = [];
          dataFlux.push(this.allFlux);
            e.features.forEach((el)=>{
              if(el.properties.dcat_all){
                    let node = {};
                    node.name = el.properties.ville;
                  if(el.properties.dcat_all[this.selectedYear]){
                      node.n = Object.keys(el.properties.dcat_all[this.selectedYear]).length;
                      for(let i in el.properties.dcat_all[this.selectedYear]){
                          let group = {};
                          group.source = el.properties.ville;
                          group.target = i;
                          group.value = 1;
                          groups.push(group);
                      }
                  }
                  if(dataFlux[0].default.find(f => f.annee == this.selectedYear && f.origine == el.properties.ville)){
                      node.n = dataFlux[0].default.find(f => f.annee == this.selectedYear && f.origine == el.properties.ville).nb_flux;

                  }
                  else{
                      node.n = 1;
                  }
                nodes.push(node);
              }
      });
        var allNodes = nodes.map(function(d){return d.name})

  var allGroups = nodes.map(function(d){return d.n})
  allGroups = [...new Set(allGroups)]
var maxLength = d3.max(allGroups);
var meanLength = d3.mean(allGroups);
var minLength = d3.min(allGroups);

  var color = d3.scaleLinear()
    .domain([minLength, meanLength - 2, meanLength, maxLength, maxLength + 10])
    .range(d3.schemeBlues[4]);

var size = d3.scaleLinear()
    .domain([1,10])
    .range([2,10]);

  var x = d3.scalePoint()
    .range([0, width])
    .domain(allNodes)


  var idToNode = {};
  nodes.forEach(function (n) {
    idToNode[n.name] = n;
  });

  var links = svg
    .selectAll('mylinks')
    .data(groups)
    .enter()
    .append('path')
    .attr('d', function (d) {
        if(!idToNode[d.target]){
            return
        }
      let start = x(idToNode[d.source].name)
      let end = x(idToNode[d.target].name)
      ;
      return ['M', start, height-30,
        'A',
        (start - end)/2, ',',
        (start - end)/2, 0, 0, ',',
        start < end ? 1 : 0, end, ',', height-30]
        .join(' ');
    })
    .style("fill", "none")
    .attr("stroke", "grey")
    .style("stroke-width", 1)

  const sortBy = (arr, k) => arr.concat().sort((a, b) => (a[k] > b[k]) ? 1 : ((a[k] < b[k]) ? -1 : 0));

  
  const nodesSorted = sortBy(nodes, 'n').reverse();

  var that = this;


  var theNodes = svg
    .selectAll("mynodes")
    .data(nodesSorted)
    .enter()
    .append("circle")
      .attr("cx", function(d){ return(x(d.name))})
      .attr("cy", height-30)
      .attr("r", function(d){ return(size(d.n))})
      .style("fill", function(d){ 
        return color(d.n)
        })
      .style(
        "stroke-width", function(d){return d.name == that.selected ? '3' : '1' }
      )
      .attr("stroke", function(d){ 
        return d.name == that.selected ? "red":"white"
        } )
      
  var labels = svg
    .selectAll("mylabels")
    .data(nodesSorted)
    .enter()
    .append("text")
      .attr("x", 0)
      .attr("y", 0)
      .text(function(d){ return(d.name)} )
      .style("text-anchor", "end")
      .attr("transform", function(d){ return( "translate(" + (x(d.name)) + "," + (height-15) + ")rotate(-45)")})
      .style("font-size", 7)
      .style("fill", "white")



  theNodes
    .on('mouseover', function (d) {
      theNodes
        .style('opacity', .3)
      d3.select(this)
        .style('opacity', 1)

      links
        .style('stroke', function (link_d) { 
            return link_d.source === d.target.__data__.name?'#FFA833':link_d.target === d.target.__data__.name ? '#33B2FF' : '#b8b8b8';
            })
        .style('stroke-opacity', function (link_d) { 
            return link_d.source === d.target.__data__.name || link_d.target === d.target.__data__.name ? 1 : .5;
            })
        .style('stroke-width', function (link_d) { 
            return link_d.source === d.target.__data__.name || link_d.target === d.target.__data__.name ? 4 : 1;
            })
      labels
        .style("font-size", function(label_d){ 
            return label_d.name === d.target.__data__.name ? 16 : 3 
            }
            )
        .attr("y", function(label_d){ 
            return label_d.name === d.target.__data__.name ? 10 : 0 
            } )
    })
    .on('mouseout', function () {
      theNodes.style('opacity', 1)
      links
        .style('stroke', 'grey')
        .style('stroke-opacity', .5)
        .style('stroke-width', '1')
      labels
        .style("font-size", 7 )
    })
    .on('click', function(d){
        that.selected = d.target.__data__.name,
        that.emitToParent(d.target.__data__.name);
        return ;
    })
   })
  },
  methods: {
    emitToParent (selectedAirport) {
      this.$emit('childToParent', selectedAirport)
      }
  },
}
</script>

<style>

</style>